<template>
  <div>
      <nav-bar :list="nav"></nav-bar>
    <div class="main">
        <div class="main-context">
      
        <article-detail v-if="art" :art="art" :nextArt="nextArt" :prevArt="prevArt"></article-detail>
    </div>
    </div>
  </div>
</template>

<script>
    import {
        articleInfo
    } from '@/api/article'
    import ArticleDetail from '@/components/article'
    import NavBar from '@/components/basic/NavBar'
    export default {
        components: {
            ArticleDetail,
            NavBar
        },
        data() {
            return {
                art: null,
                prevArt: "",
                nextArt: '',
                nav: [],
            }
        },
        methods: {
            showLoad() {
                return this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255, 255, 255, 0.7)'
                });
            },
            checkArt(data) {
                if (data.code == "1") {
                    this.art = data.art
                    this.prevArt = data.prevArt
                    this.nextArt = data.nextArt
                    data.nav.push({
                        type_name: '文章详情'
                    })
                    this.nav = data.nav
                    document.title = data.art.title
                } else {
                    this.art = false
                }
            },
        },
        created() {
            const loading = this.showLoad()
            articleInfo(this.$route.params.articleId).then(result => {
                loading.close();
                this.checkArt(result)
            })
        },
        beforeRouteUpdate(to, from, next) {
            const loading = this.showLoad()
            articleInfo(to.params.articleId).then(result => {
                loading.close();
                this.checkArt(result)
                next()
            })

        }
    }
</script>

<style>

</style>